export enum FiboSearchHeadline {
  TAX_BRAND = 'tax_brand',
  TAX_PRODUCT_TAG = 'tax_product_tag',
  TAX_PRODUCT_CATEGORY = 'tax_product_cat',
  PRODUCT = 'product',
  MORE_PRODUCTS = 'more_products',
}

export const FiboSearchHeadlineText = {
  [FiboSearchHeadline.TAX_BRAND]: 'Brands',
  [FiboSearchHeadline.TAX_PRODUCT_TAG]: 'Tags',
  [FiboSearchHeadline.TAX_PRODUCT_CATEGORY]: 'Categories',
  [FiboSearchHeadline.PRODUCT]: 'Products',
  [FiboSearchHeadline.MORE_PRODUCTS]: 'More Products',
};

export enum FiboSearchType {
  HEADLINE = 'headline',
  TAXONOMY = 'taxonomy',
  PRODUCT = 'product',
}

export enum TaxonomyType {
  PRODUCT_CATEGORY = 'product_cat',
  BRAND = 'brand',
}
